"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedoButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
const models_1 = require("@completeanatomy/models");
const ui_1 = require("@completeanatomy/ui");
const ToolbarButton_1 = __importDefault(require("../ToolbarButton"));
function RedoButton({ onLongPress, selected, isToolsMode = false, }) {
    const bridge = (0, bridge_1.useBridge)();
    const isRedoActive = (0, models_1.useRedoActive)(isToolsMode);
    const onClick = () => {
        if (isToolsMode) {
            bridge === null || bridge === void 0 ? void 0 : bridge.toolkitHistoryAction({ type: bridge_schema_1.ToolType.Redo });
            return;
        }
        bridge === null || bridge === void 0 ? void 0 : bridge.historyRedoPressed();
    };
    return (Boolean(isRedoActive) && ((0, jsx_runtime_1.jsx)(ToolbarButton_1.default, { onClick: onClick, onLongPress: onLongPress, title: (0, i18n_1.Localized)(i18n_1.Strings.header.redo), icon: ui_1.Icons.Tool_Undo_Redo, selected: selected, flip: true, "data-e2e": 'RedoButton_ToolbarButton' })));
}
exports.RedoButton = RedoButton;
